<template>
  <div v-if="!loading" id="chart">
    <apexchart
      type="line"
      height="340"
      :width="width"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
  <div v-else>
    <div class="text-center">
      <b-spinner small label="Small Spinner" type="grow"></b-spinner>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    apexchart: VueApexCharts
  },
  props: {
    loading: {
      type: Boolean,
      required: false
    },
    series: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      width: 0, 
      height: '100px',
      chartOptions: {
        chart: {
          type: "line",
          stacked: true,
          stackType: 'normal',
          zoom: false,
          toolbar:{
            // offsetX: "20%",
            show:true,
            tools: {
              download: true,
            }
          },          
          animations: {
            enabled: false,
            easing: 'linear',
            speed: 200,
          }
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        stroke: {
          curve: 'smooth',
          width: [0, 0, 3]
          
        },
        markers: {
            size: 3,
        },
        title: {
          // text: "Flúxo de Caixa"
        },
        colors: ["#becf16", "#f9b11c", "gray"],
        dataLabels: {
          enabled: false,
          enabledOnSeries: [1]
        },
        labels: [],
        xaxis: {
          labels: {
            // formatter: function (value, timestamp) {
            //   console.log(value)
            //   console.log(timestamp)
            //   return new Date(timestamp) // The formatter function overrides format property
            // }, 
            
          format: 'dd/MM/yy',
          },
          type: "datetime",
        },
        yaxis: {
          labels: {
            formatter: (row, col, cell, index) => this.formatterMoeda(row)
          }
        }
      }
    };
  },
  mounted() {
    //console.log('width',this.width)
  },
  methods: {
    formatterMoeda(value) {
      let valorFormatado = value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
      return valorFormatado;
    },
    updateLabels(labels) {
      this.chartOptions.labels = labels;
    }
  }
};
</script>
